module.exports = __webpack_public_path__ + "178569a4b51bf4a56e2b9303633fc285.png";